import React from 'react';

const SUN_RAYS = 'M10 1.8v2.2M10 16v2.2M1.8 10H4M16 10h2.2M4.2 4.2l1.6 1.6M14.2 14.2l1.6 1.6M4.2 15.8l1.6-1.6M14.2 5.8l1.6-1.6';
const MOON = 'M16.5 12.4A7 7 0 0 1 7.6 3.5a7 7 0 1 0 8.9 8.9z';

/**
 * The icon for a colour scheme: a sun for light, an outlined moon for dark and
 * a filled moon for black. Cycle buttons show the scheme they switch to.
 */
export default function ThemeModeIcon({ mode, size = 18 }) {
  if (mode === 'light') {
    return (
      <svg width={size} height={size} viewBox="0 0 20 20" aria-hidden="true">
        <circle cx="10" cy="10" r="3.6" fill="none" stroke="currentColor" strokeWidth="1.4" />
        <path d={SUN_RAYS} fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" />
      </svg>
    );
  }
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" aria-hidden="true">
      <path d={MOON} fill={mode === 'black' ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.4" />
    </svg>
  );
}
